import { match } from 'ts-pattern';
import { GrillBaseVariant } from '../__generated/model/versions/v2.js';
export const migrateToV2 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().with({
            type: 'GrillBase'
        }, (entity)=>({
                ...entity,
                variant: GrillBaseVariant.Default
            })).with({
            type: 'CornerFiller'
        }, ({ connerFillerType, ...entity })=>({
                ...entity,
                // Just a typo fix
                cornerFillerType: connerFillerType
            })).with({
            type: 'SinkBase'
        }, (entity)=>({
                ...entity,
                applianceId: null
            })).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v02.js.map